import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareBehindSquare4: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-1-stroke-1.5-IconSquareBehindSquare4"><Path fillRule="evenodd" clipRule="evenodd" d="M8 8V3.25C8 2.55964 8.55964 2 9.25 2H20.75C21.4404 2 22 2.55964 22 3.25V14.75C22 15.4404 21.4404 16 20.75 16H16V20.75C16 21.4404 15.4404 22 14.75 22H3.25C2.55964 22 2 21.4404 2 20.75V9.25C2 8.55964 2.55964 8 3.25 8H8ZM9.25 16C8.55964 16 8 15.4404 8 14.75V9.5H3.5V20.5H14.5V16H9.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquareBehindSquare4;
